var message_bar_session_storage = JSON.parse(sessionStorage.fsb_payload);

var goal = message_bar_session_storage.bars[0].goal
var currency_symbol = message_bar_session_storage.bars[0].currency_symbol;
var currency_code  = message_bar_session_storage.bars[0].currency_code; 
var currency_exchange_rate = message_bar_session_storage.bars[0].currency_exchange_rate 
var initial_message = message_bar_session_storage.bars[0].message_one;
var secondary_message = message_bar_session_storage.bars[0].message_two.replace("", currency_symbol);
var free_shipping_message = message_bar_session_storage.bars[0].message_three;
var currency_code  = message_bar_session_storage.bars[0].currency_code;

function bannerPriceUpdate() {
  //alert(currency_code);
  
  if(currency_code == "USD"){
  	currency_symbol = "$";
  }
  if(currency_code == "CAD"){
    currency_symbol = "$";
  }
  if(currency_code == "EUR"){
  	currency_symbol = "€";
  }
  if(currency_code == "GBP"){
  	currency_symbol = "£";
  }
  
   var total_cart_price = $('.product-price__price-data')[0].innerHTML.split(" ")[0].replace(currency_symbol, ""); 

  //var total_cart_price = $('.amount-price').children('.money')[0].innerHTML.split(" ")[0].replace(currency_symbol, ""); 
  var goal_converted = parseFloat(goal);
  var total_cart_price_converted = parseFloat(total_cart_price);
  
  var running_total = goal_converted - total_cart_price_converted;
  
//   console.log("total_cart_price : ", total_cart_price);
//   console.log("goal_converted: ", goal_converted);
//   console.log("total_cart_price_converted: ", total_cart_price_converted);
//   console.log("running_total: ", running_total);
  
//   console.log("currency_symbol: ", currency_symbol);
  
  console.log("BOLDCURRENCY.currentCurrency: ", currency_code);
 
  
  if(running_total == goal_converted){
    var message = initial_message.replace("", currency_symbol).replace("", goal_converted);
    $('#fsb_bar').html(message);
//     console.log("Running Total is EQUAL TO Goal Converted");
    
  } else if( running_total > 0 ) {        
    var message = secondary_message.replace("", running_total.toFixed(2));    
    $('#fsb_bar').html( message );
//     console.log("Running Total is GREATHER TO Goal Converted");
  } else {
     $('#fsb_bar').html( free_shipping_message );
//      console.log("LOOP IS ON ELSE!");
  }

} 
  


